import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, ListGroup, Button, Card } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import Message from '../components/Message';
import { addToCart, removeFromCart, clearCartItems } from '../slices/cartSlice';

const CartScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  const addToCartHandler = (product, qty) => {
    dispatch(addToCart({ ...product, qty }));
  };
  const dailystockbag = () => {
    navigate('/login?redirect=/dailystocksform');
  };
  const removeFromCartHandler = (id) => {
    dispatch(removeFromCart(id));
  };

  const checkoutHandler = () => {
    navigate('/login?redirect=/shipping');
  };
  const salebag = () => {
    navigate('/login?redirect=/salesform');
  };
  const insubag = () => {
    navigate('/login?redirect=/insurancesform');
  };
  
  const supplybag = () => {
    navigate('/login?redirect=/supplysform');
  };
  const contactbag = () => {
    navigate('/login?redirect=/contact');
  };
  const servicebag = () => {
    navigate('/login?redirect=/services');
  };
  
  const stockbag = () => {
    navigate('/login?redirect=/stocksform');
  };
  const openingstockbag = () => {
    navigate('/login?redirect=/openingstocksform');
  };
  const Transferbag = () => {
    navigate('/login?redirect=/transfersform');
  };

  const Expensebag = () => {
    navigate('/login?redirect=/expenselist');
  };
  const Productbag = () => {
    navigate('/login?redirect=/productlist');
  };
  const Cashbag = () => {
    navigate('/login?redirect=/cashlist');
  };
  
  const Customerbag = () => {
    navigate('/login?redirect=/customeruserlist');
  };
  const Supplierbag = () => {
    navigate('/login?redirect=/supplierlist');
  };
  
  return (
    <Row>
      <Col md={8}>
        <h1 style={{ marginBottom: '20px' }}>Shopping Cart</h1>
        {cartItems.length === 0 ? (
          <Message>
            Your cart is empty <Link to="/house/HomeScreen">Go Back</Link>
          </Message>
        ) : (
          <ListGroup variant="flush">
            {cartItems.map((item) => (
              <ListGroup.Item key={item._id}>
                <Row>
                  <Col md={2}>
                    {item.images?.length > 0 && (
                      <img
                        src={item.images[0]}
                        alt="Thumbnail"
                        className="thumbnail-img me-2"
                        style={{
                          width: '40px',
                          height: '40px',
                          objectFit: 'cover',
                        }}
                      />
                    )}
                  </Col>
                  <Col md={3}>
                    <Link to={`/product/${item._id}`}>{item.name}</Link>
                  </Col>
                  <Col md={2}>${item.price}</Col>
                  <Col md={2}>
                    <Button
                      type="button"
                      variant="light"
                      onClick={() =>
                        addToCartHandler(item, item.qty > 1 ? item.qty - 1 : 1)
                      }
                      disabled={item.qty === 1}
                    >
                      -
                    </Button>
                    <span className="mx-2">{item.qty}</span>
                    <Button
                      type="button"
                      variant="light"
                      onClick={() =>
                        addToCartHandler(item, item.qty + 1)
                      }
                      disabled={item.qty === item.countInStock}
                    >
                      +
                    </Button>
                  </Col>
                  <Col md={2}>${item.price * item.qty}</Col>
                  <Col md={1}>
                    <Button
                      type="button"
                      variant="light"
                      onClick={() => removeFromCartHandler(item._id)}
                    >
                      <FaTrash />
                    </Button>
                  </Col>
                </Row>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Col>
      <Col md={4}>
        <Card>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>
                Subtotal ({cartItems.reduce((acc, item) => acc + item.qty, 0)})
                items
              </h2>
              $
              {cartItems
                .reduce((acc, item) => acc + item.qty * item.price, 0)
                .toFixed(2)}
            </ListGroup.Item>
            <ListGroup.Item>
              <Button
                type="button"
                className="btn-block"
                disabled={cartItems.length === 0}
                onClick={salebag}
              >
                Proceed To SalesForm
              </Button><br />
              <Button
                type="button"
                className="btn-block"
                disabled={cartItems.length === 0}
                onClick={checkoutHandler}
              >
                Proceed To Checkout
              </Button><br />
              
              <Button
                type="button"
                className="btn-block"
                disabled={cartItems.length === 0}
                onClick={dailystockbag}
              >
                Proceed To DailyStockForm
              </Button>

              <Button
                type="button"
                className="btn-block"
                style={{display: 'none'}}
                disabled={cartItems.length === 0}
                onClick={supplybag}
              >
                Proceed To SupplyForm
              </Button>
              <Button
                type="button"
                className="btn-block"
                style={{display: 'none'}}
                disabled={cartItems.length === 0}
                onClick={Transferbag}
              >
                Proceed To TransferForm
              </Button>
              <Button
                type="button"
                className="btn-block"
                style={{display: 'none'}}
                disabled={cartItems.length === 0}
                onClick={stockbag}
              >
                Proceed To Stock
              </Button>
              <Button
                type="button"
                className="btn-block"
                style={{display: 'none'}}
                disabled={cartItems.length === 0}
                onClick={insubag}
              >
                Proceed To InsuForm
              </Button><br />
              <Button
                type="button"
                className="btn-block"
                style={{display: 'none'}}
                disabled={cartItems.length === 0}
                onClick={openingstockbag}
              >
                Proceed To Op-Stock
              </Button><br />
              <Button
                type="button"
                className="btn-block"
                style={{display: 'none'}}
                onClick={Expensebag}
              >
                Credits / Debits
              </Button><br />
              <Button
                type="button"
                className="btn-block"
                style={{display: 'none'}}
                onClick={Productbag}
              >
                Itemlist
              </Button><br />
              <Button
                type="button"
                className="btn-block"
                style={{display: 'none'}}
                onClick={Cashbag}
              >
                Cash Collected
              </Button><br />
              <Button
                type="button"
                className="btn-block"
                style={{display: 'none'}}
                onClick={Customerbag}
              >
                Customerlist
              </Button><br />
              <Button
                type="button"
                className="btn-block"
                style={{display: 'none'}}
                onClick={Supplierbag}
              >
                Supplierlist
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={servicebag}
              >
                Services
              </Button>
              <Button
                type="button"
                className="btn-block"
                
                onClick={contactbag}
              >
                Contact Us
              </Button>

              <Button 
                            type="button"
                            className="btn-block"
                            disabled={cartItems.length === 0}
                           onClick={() => dispatch(clearCartItems())} 
                           >
                          Clear Cart
              </Button>

            </ListGroup.Item>
          </ListGroup>
        </Card>
      </Col>
    </Row>
  );
};

export default CartScreen;